import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

// Reuse the variant response already fetched by the picker; no extra requests.
class MoxCardDetails extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.updateDetails, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.pendingSelection = null;
    super.disconnectedCallback();
  }
  updateDetails = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const selection = event.promise;
    this.pendingSelection = selection;
    selection.then(({ detail }) => {
      if (!this.isConnected || this.pendingSelection !== selection || !detail?.html) return;
      if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
      const updated = detail.html.querySelector('mox-card-details');
      const details = updated?.querySelector('dl');
      const current = this.querySelector('dl');
      if (!details || !current) return;
      current.replaceWith(details.cloneNode(true));
      this.dataset.productId = updated.dataset.productId;
    }).catch(error => {
      if (error?.name !== 'AbortError') console.warn('[mox-card-details]', error);
    });
  };
}
if (!customElements.get('mox-card-details')) customElements.define('mox-card-details', MoxCardDetails);
